'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { ROUTES, STORAGE_KEY } from '@/constants';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import { useAuthStore } from '@/stores/AuthStore';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';

const LOGIN_PROGRESS_PATHS = [
  ROUTES.LOGIN.pathname,
  ROUTES.AUTH.pathname,
  ROUTES.CROSS_DOMAIN_AUTH.pathname,
  ROUTES.CROSS_DOMAIN_CALLBACK.pathname,
];

const SIGNUP_PROGRESS_PATHS = [
  ROUTES.JOIN_COMMON.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
  ROUTES.EASY_CERTIFICATION_CALLBACK.pathname,
  ROUTES.JOIN_COMPLETE.pathname,
  ROUTES.MY_POLICY_FILTER.pathname,
  ROUTES.POLICY_FILTER.pathname({ situation: 'join' }),
];

/**
 * 로그인 버튼을 클릭했을 때 IS_LOGIN_PROGRESS를 true로 설정하고
 * 로그인이 완료되었을 때(회원 가입시에는 회원가입 완료 이후)에 로깅한다.
 */
export const useLoginGtmEventListener = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const isNewUser = useIsNewUser();
  const pathname = usePathname();

  useEffect(() => {
    const isLoggingInPaths = [
      ...LOGIN_PROGRESS_PATHS,
      ...SIGNUP_PROGRESS_PATHS,
    ].some((path) => pathname === path);

    if (isNewUser) return;
    if (isLoggingInPaths) return;

    const noLoginEvent = !!sessionStorage.getItem(
      STORAGE_KEY.IS_LOGIN_PROGRESS,
    );

    if (isLogin === true && noLoginEvent) {
      sessionStorage.removeItem(STORAGE_KEY.IS_LOGIN_PROGRESS);

      trackGtmEvent(GTM_EVENT_TYPE.LOGIN, {
        method: sessionStorage.getItem(STORAGE_KEY.SIGNUP_METHOD) ?? '',
      });
    }
  }, [isLogin, pathname, isNewUser]);
};
